import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { AnchorLink } from 'components/common/ButtonLink';
import { StyledPipe } from './StyledPipe';
import ViewDownloadSourceModalDialog from './DownloadSourceModal';

export const DownloadSourceLink = ({ productKey }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <>
      {/* Add analytics for it */}
      <AnchorLink
        href={`/purchase/my/download-source/${productKey}`}
        data-cy="actions-section-download-source-button"
      >
        <FormattedMessage id="mac.licenses.download.source" defaultMessage="Download Source" />
      </AnchorLink>
      <StyledPipe />
      <ViewDownloadSourceModalDialog
        isModalOpened={isModalOpened}
        onClose={() => setIsModalOpened(false)}
      />
    </>
  );
};
